const useDateSummaryDialogStyles = () => {
    return {
        dateFrame: {
            display: 'flex',
            flexDirection: 'column',
            py: (theme) => theme.spacing(2),
            px: (theme) => theme.spacing(2),
            backgroundColor: (theme) => theme.palette.common.white,
            borderRadius: 3,
            border: (theme) => `1px solid ${theme.palette.grey[200]}`
        },
        boxTop: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: (theme) => theme.spacing(1.5),
            mb: (theme) => theme.spacing(1.5)
        },
        boxBottom: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1.5
        }
    };
};
export default useDateSummaryDialogStyles;
